// Apply "Keep server" for a parked sync conflict (drop outbox item, restore server copy).
import { removeOutboxItem, removeConflict } from "./outbox";
import { cacheSetEntity, guessSliceFromUrl } from "./cache";
import { deletePhotoLocally } from "./photos";
import _ from "lodash";

export const applyKeepServerFromConflict = async (conflict) => {
  const item = conflict.outboxItem;
  if (!item) return;
  await removeOutboxItem(conflict.outboxId || item.id);
  await removeConflict(conflict.outboxId || item.id);
  const slice = item.entitySlice || guessSliceFromUrl(item.url);
  if (slice && conflict.serverRecord) {
    await cacheSetEntity(slice, conflict.serverRecord);
  }
  if (item.bodyKind === "formData") {
    await Promise.all(
      _.map(
        _.filter(item.entries, { kind: "file" }),
        (entry) => deletePhotoLocally(entry.localPath)
      )
    );
  }
};
